import { PAIN_ITEMS } from "../content";
import "./PainGrid.css";

/** «¿Te suena?» (#por-que): cómo se organiza hoy y qué deja de pasar con
 * Torneos123. Sin rojo: el «antes» va en gris y el «después» en verde. */
export function PainGrid() {
  return (
    <section id="por-que" className="t123-section t123-section--soft t123-pain" aria-labelledby="t123-pain-title">
      <div className="t123-shell">
        <div className="t123-heading-center">
          <h2 id="t123-pain-title" className="t123-h2">
            ¿Te suena?
          </h2>
          <p className="t123-lead">
            Así se organiza un torneo en muchos clubes. Esto es lo que deja de pasar con Torneos123.
          </p>
        </div>

        <ul className="t123-pain__grid">
          {PAIN_ITEMS.map((item) => (
            <li key={item.before} className="t123-pain__card">
              <span className="t123-pain__tag">Antes</span>
              <p className="t123-pain__before">{item.before}</p>
              <span className="t123-pain__divider" aria-hidden="true">
                <span className="t123-pain__arrow">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 5v14M6 13l6 6 6-6" />
                  </svg>
                </span>
              </span>
              <span className="t123-pain__tag t123-pain__tag--after">Con Torneos123</span>
              <p className="t123-pain__after">{item.after}</p>
            </li>
          ))}
        </ul>

        <div className="t123-pain__close">
          <p>Cuéntanos cómo organizas hoy y te enseñamos cómo se hace en Torneos123.</p>
          <a className="t123-btn t123-btn--primary t123-btn--arrow" href="#demo">
            Pedir demo
          </a>
        </div>
      </div>
    </section>
  );
}
